<template>
  <div class="personal-page-wrapper">
    <h1>Личные данные</h1>
    <ul class="profile_submenu">
      <li>
        <router-link to="/personal">
          {{ "Личные данные" }}
        </router-link>
      </li>
      <li>
        <router-link to="/password">
          {{ "Изменить пароль" }}
        </router-link>
      </li>
    </ul>
    <validation-observer
        v-slot="{ handleSubmit }"
        ref="refFormObserver"
    >
      <b-form
          @submit.stop.prevent="handleSubmit(formToChangePassword)"
          class="form validate"
      >
        <validation-provider
            v-slot="validationContext"
            name="old_password"
            rules="required|min:6"
        >
          <b-form-group
              label="Старый пароль"
              label-for="old_password"
          >
            <b-form-input
                placeholder="Введите старый пароль"
                id="old_password"
                name="old_password"
                type="password"
                :state="getValidationState(validationContext)"
                v-model="oldPassword"
                trim
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider
            v-slot="validationContext"
            name="new_password"
            rules="required|min:6"
        >
          <b-form-group
              label="Новый пароль"
              label-for="new_password"
          >
            <b-form-input
                placeholder="Введите новый пароль"
                id="new_password"
                name="new_password"
                type="password"
                :state="getValidationState(validationContext)"
                v-model="newPassword"
                trim
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider
            v-slot="validationContext"
            name="password_confirmation"
            rules="required|min:6"
        >
          <b-form-group
              label="Подтвердите новый пароль"
              label-for="password_confirmation"
          >
            <b-form-input
                placeholder="Введите новый пароль еще раз"
                id="password_confirmation"
                name="password_confirmation"
                type="password"
                :state="getValidationState(validationContext)"
                v-model="newPasswordConf"
                trim
            />
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-button type="submit" variant="primary" :disabled="isSubmitting">
          <b-spinner small v-if="isSubmitting" class="mr-1" />
          {{ isSubmitting ? 'Сохранение...' : 'Сохранить' }}
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BSpinner
} from 'bootstrap-vue'
import {ValidationObserver, ValidationProvider} from 'vee-validate'

const {
  mapActions,
} = createNamespacedHelpers('user');

export default {
  name: 'PersonalPsw',
  components: {
    BFormInput,
    BButton,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    ValidationObserver,
    ValidationProvider,
    BSpinner
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      newPasswordConf: '',
      isSubmitting: false
    };
  },
  methods: {
    ...mapActions(['changePassword']),
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },
    formToChangePassword() {
      // Check if passwords match
      if (this.newPassword !== this.newPasswordConf) {
        this.$bvToast.toast('Новые пароли не совпадают', {
          title: `Ошибка валидации`,
          variant: 'danger',
          solid: true,
        });
        return;
      }

      this.isSubmitting = true;

      const options = {
        old_password: this.oldPassword,
        new_password: this.newPassword,
        new_password_conf: this.newPasswordConf,
      };

      this.changePassword(options)
          .then(() => {
            this.$bvToast.toast('Ваш пароль был успешно изменен', {
              title: `Успешно! Пароль обновлен`,
              variant: 'success',
              solid: true,
            });
            // Clear form
            this.oldPassword = '';
            this.newPassword = '';
            this.newPasswordConf = '';
            this.$refs.refFormObserver.reset();
          })
          .catch((err) => {
            console.error('Error changing password:', err);
            this.$bvToast.toast('Проверьте правильность старого пароля', {
              title: `Ошибка! Не удалось изменить пароль`,
              variant: 'danger',
              solid: true,
            })
          })
          .finally(() => {
            this.isSubmitting = false;
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-page-wrapper {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.profile_submenu {
  display: flex;
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
  border-bottom: 2px solid #e9ecef;

  li {
    margin-right: 20px;

    a {
      display: block;
      padding: 10px 15px;
      text-decoration: none;
      color: #6c757d;
      border-bottom: 2px solid transparent;
      margin-bottom: -2px;

      &:hover,
      &.router-link-active {
        color: #7367f0;
        border-bottom-color: #7367f0;
      }
    }
  }
}
</style>
